import {z} from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {TemplateFreeFormSectionSchema} from './templateFreeFormSection'

export const TemplateFreeFormSchema = buildEntrySchemaFor('templateFreeForm', {
  fields: z.object({
    sections: z.array(TemplateFreeFormSectionSchema),
  }),
})

export type TemplateFreeForm = z.infer<typeof TemplateFreeFormSchema>
